import React from 'react';

const ServiceCard = ({ 
  title, 
  description, 
  image, 
  isReversed = false, 
  hasGradient = false,
  rounded = false,
  showHeading = false // NEW PROP
}) => {
  const gradientClass = hasGradient 
    ? 'bg-gradient-to-r from-purple-900 via-purple-600 to-orange-500' 
    : 'bg-white';

  const textColorClass = hasGradient ? 'text-white' : 'text-gray-900';
  const descriptionColorClass = hasGradient ? 'text-gray-200' : 'text-gray-600';
  const roundedImage = rounded ? 'rounded-lg shadow-xl' : '';

  return (
    <div className={`py-16 sm:py-24 ${gradientClass}`}>
      <div className="px-6 mx-auto max-w-7xl lg:px-8">

        {/* Only show on first section if flag is true */}
        {showHeading && (
          <h2 className={`mb-16 text-3xl font-bold text-center sm:text-4xl ${textColorClass}`}>
            Our Services
          </h2>
        )}

        <div className={`grid items-center grid-cols-1 gap-16 lg:grid-cols-2 ${isReversed ? 'lg:grid-flow-col-dense' : ''}`}>
          {/* Text Content */}
          <div className={`flex flex-col justify-center ${isReversed ? 'lg:col-start-2' : ''}`}>
            <div className="max-w-xl px-4 mx-auto lg:px-0">
              <h3 className={`text-3xl font-bold tracking-tight ${textColorClass} sm:text-4xl mb-6`}>
                {title}
              </h3>
              <p className={`text-lg leading-8 ${descriptionColorClass}`}>
                {description}
              </p>
            </div>
          </div>

          {/* Image */}
          <div className={`flex items-center justify-center ${isReversed ? 'lg:col-start-1' : ''}`}>
            <div className="relative w-full max-w-2xl px-4 lg:px-0">
              <img
                src={image}
                alt={title}
                className={`w-full h-auto ${roundedImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
